module.exports = __webpack_public_path__ + "img/insurance-deductible-icon.e1845281.svg";